module.exports = __webpack_public_path__ + "static/media/f123Gh.86ff7848.jpeg";